import styles from "./row.component.module.scss";
import cn from "../../../../Utils/class-names.utils";

interface RowComponentProps {
 title: string;
 children: React.ReactNode;
}

const RowComponent = ({ title, children }: RowComponentProps) => {
  return (
    <div className={styles.row}>
      <div className={styles.titleContainer}>
        <div className={styles.innerWrapper}>
          <div className={styles.labelWrapper}>
            <label
              htmlFor="contract-length-input"
              className={cn(styles.label, 'm-0')}
            >
              {title}
            </label>
          </div>
        </div>
      </div>

      <div className={styles.childrenContainer}>
        {children}
      </div>
    </div>
  );
};

export default RowComponent;